// A trace tab's address, the id after `trace:` in the URL and the tab key:
// `<session id>` is the whole conversation, `<session id>@<ms>` the
// conversation up to that moment (epoch milliseconds). A request opened from
// the log is addressed by its own time; any moment addresses the conversation
// up to it, with the request at or before it as the focal one. A bare id (a
// request's or a session's, from a thread hop or an older link) is accepted
// too and takes its full address once the trace lands.
export function parseTraceAddress(address) {
    const text = String(address || "");
    const at = text.indexOf("@");
    if (at <= 0) return { sessionId: null, untilMs: null, id: text };
    const untilMs = Number(text.slice(at + 1));
    return { sessionId: text.slice(0, at), untilMs: Number.isFinite(untilMs) ? untilMs : null, id: null };
}

// The address of a trace getTrace answered: its session at its bound when it
// has one, its session alone when it is the whole conversation.
export function traceAddressOf(trace) {
    if (trace?.sessionId && Number.isFinite(trace.untilMs)) return `${trace.sessionId}@${trace.untilMs}`;
    if (trace?.requestId === null) return trace.sessionId || trace.id;
    return trace?.id;
}

// The address a log row opens: a request row is its session at the request's
// time, a session row is its session.
export function traceAddressOfRow(row) {
    if (row?.sessionId && row.sessionId !== row.id && Number.isFinite(row.timestamp)) return `${row.sessionId}@${row.timestamp}`;
    return row?.id;
}

// The request a trace tab is focused on, for everything keyed by request id
// (the request log's rows, command attribution, prev/next): the request an
// answered trace names; a request row's own id while it loads; a bare id
// until it lands; nothing for a whole conversation or a bound with no request.
export function focalRequestIdOf(data) {
    if (!data) return "";
    if ("requestId" in data) return data.requestId || "";
    if (data.placeholder) return data.sessionId ? "" : data.id;
    return data.sessionId && data.sessionId !== data.id ? data.id : "";
}
